var processInclude = require('base/util');
require('int_gtm/datalayer');


$(document).ready(function () {
    processInclude(require('./components/analytics'));
});
